import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./mainVariables.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesFile from "./routes";
import { ThemeProvider } from "./ThemeProvider";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider>
      <Router>
        <RoutesFile />
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
